<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
  .input-wdt{width: 100%;}
  .level-inner-wrap{display: flex; justify-content: flex-start; align-items: center;}
  .level-inner-wrap .select-level-drop{width: 70%; margin-right: 15px;}
  .create-category{display: flex; justify-content: flex-start; align-items: center;}
  .create-category .input-wdt2{width: 80%; margin-right: 15px;}
  .con-img-upload {background: #efebeb;}
  .ql-container.ql-snow {min-height: 150px;}
  .profile-edit .ql-editor {min-height: 150px;}
  .countDivder{margin: 30px 0 0;}
  .rqrd{color: #f00;}
  .img-preview{
      width: 200px;
      height: 150px;
      display: inline-flex;
      word-break: break-all;
      justify-content: center;
      align-items: center;
      background: #f1f1f1;
      margin:0 10px 10px 0;
      background: #f1f1f1;
      border: 1px solid #ddd;
      border-radius: 5px;
      overflow: hidden;
      float: left;
  }
  .image-box{
    min-height:80px;
  }
  .img-preview img{ width:100%}
</style>
<template>
  <div id="exhibitor-edit-tab-account">
    <!-- Content Row -->
    <div class="vx-row">     

      <div class="vx-col md:w-1/1 w-full mt-0">
         <div>
            <input type="file" name="fileUpload" multiple class="hidden" ref="update_resource_input" @change="upload_resources" accept="image/*" v-validate="'required'">
            <vs-button class="mr-4 mb-4" @click="$refs.update_resource_input.click()">Browse</vs-button>  
            <label>Supported file types: JPG, PNG, GIF & Max(10 MB)</label>                 
         </div>  
         <span class="text-danger text-sm"  v-show="errors.has('fileUpload')">{{ errors.first('fileUpload') }}</span> 
         <div class="vx-col md:w-1/1 w-full mt-2 image-box">
            <!-- <a :href="file">File</a> -->
            <span class="img-preview" v-for="src in data_local.photoUrls">
              <img :src="src">
            </span>
         </div>        
      </div>   

      <div class="vx-col md:w-1/1 w-full mt-1">
        <vs-divider></vs-divider>
      </div> 

      <div class="vx-col md:w-1/3 w-full mt-2">
        <label>Photo Album</label>
        <vs-input class="inputx w-full mt-2" name="photoDirectory" :disabled="data_local.photoDirectoryDisable" v-model="data_local.photoDirectory" v-validate="'required'"/>
        <span class="text-danger text-sm"  v-show="errors.has('photoDirectory')">{{ errors.first('photoDirectory') }}</span>
      </div>


    </div>   


     


    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class=" mt-2" @click="$router.push('/event/photowalls')">Back To List</vs-button>
          <vs-button class="ml-auto mt-2" @click="before_save" :disabled="!validateForm">Upload Photos</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor'

import modulePhotowallManagement from '@/store/photowall-management/modulePhotowallManagement.js'

export default {
  components: {
    vSelect,
    quillEditor,
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc:this.data.ResourceFiles,
      ResourceFiles: []
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    successUpload(){
      this.$vs.notify({color:'success',title:'Successfully Uploaded'})
    },
    before_save() {
       this.$validator.validateAll().then(result => {
        if(result) {
          // if form have no errors
          this.save_changes();
        }
      })
    },
    upload_resources(input){
      if (input.target.files.length) { 
        for(var i = 0; i < input.target.files.length ; i++) {
          const file = input.target.files[i]
          const metadata = {'contentType': file.type}     
          //let  filename = file.name
          //filename = filename.split('.').pop();
          //console.log(filename) 
          const validImageTypes = ['image/gif', 'image/jpeg', 'image/png']
          if (!validImageTypes.includes(file.type)) {
            alert('Only files allowed.')
            return false
          }
          let FileSize = file.size / 1024 / 1024;
          if(FileSize > 10)
          {
            alert("Uploaded file size exceeds 10 MB");
            return false;
          }
          const reader = new FileReader()
          reader.onload = e => {
            this.data_local.photoUrls.unshift(e.target.result)
          }    
          reader.readAsDataURL(file);
          //this.data_local.photoUrls.push(file.name)
          this.ResourceFiles.push(file)   
          //this.data_local.file = file.webkitRelativePath   
          //console.log(this.data_local.file);    
        }        
      }
    },
    
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading()

      this.data_local.ResourceFiles = this.ResourceFiles
      this.ResourceFiles = []
      
      const Id = this.$route.params.exhibitorId ? this.$route.params.exhibitorId : null
      //alert(Id);
      if (Id) {
        this.$store.dispatch('photowallManagement/updatePhotowall', { id: Id, data: this.data_local})
          .then(res => { 
            //alert(res.message)   
            this.$vs.notify({
              color: 'success',
              position: 'top-center',
              title: 'Photo Wall',
              text: res.message
            })
            this.$vs.loading.close()        
          }).catch(err => {          
          console.error(err) 
          })
      } else {
        this.$store.dispatch('photowallManagement/addPhotowall', { data: this.data_local})
          .then(res => { 
            //alert(res.message) 
            this.$vs.notify({
              color: 'success',
              position: 'top-center',
              title: 'Photo Wall',
              text: res.message
            })
            this.$vs.loading.close()  
            if (res.status == 200) {
              this.$router.push('/event/photowalls');             
            }            
          }) 
          .catch(err => {          
          //console.error(err) 
          })
      }
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
      this.imgSrc = this.data.Logo
    },
    getPhotoDirectryList(){
      this.$store.dispatch('photowallManagement/fetchPhotowalls')
        .then(res => { 
          //this.attendessList = res;                    
          //console.log(res);
          for(let i=0; i<res.length; i++){            
            console.log(res[i]);            
            // this.photoWallList.push({ 
            //     photoDirectory:res[i].photoDirectory,
            //     photourl:res[i].photoUrls
            // })
          }
        });
    }
    
  },
  created () {
    
    if (!modulePhotowallManagement.isRegistered) {
      this.$store.registerModule('photowallManagement', modulePhotowallManagement)
      modulePhotowallManagement.isRegistered = true
    } 
    //this.getPhotoDirectryList()
    
  }


}
</script>
